import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import SettingsContent from '../Wrapper.vue';
import Index from './Index.vue';
import Show from './Show.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/booking-widgets'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_booking_widgets_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/booking-widgets'),
      component: SettingsContent,
      props: () => ({
        headerTitle: '',
        icon: '',
        showBackButton: false,
        fullWidth: true,
        fixedHeight: true,
      }),
      children: [
        {
          path: 'new',
          name: 'settings_booking_widgets_new',
          component: Show,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':bookingWidgetId',
          name: 'settings_booking_widgets_show',
          component: Show,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
